import React, { useEffect, useContext } from 'react';

import { useNavigate } from 'react-router-dom';

import { Header, Footer, HeaderBox } from '../../components/imports'

import { HeaderProfile, ProfileMenu } from '../../components/profile-prive'

import { APP_NAME } from '../../constants/general'

import { Context } from '../../class/Context'

import Func from '../../class/Func'

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import AddCardForm from '../../components/AddCardFromStripe';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

function PaiementsAjouterCarte() {

    const navigate = useNavigate()

    const context = useContext(Context)

    useEffect(() => {

        Func.session(context, navigate)

        document.title = "Ajouter une carte de paiement - " + APP_NAME

    }, [])

    return (

        <div>

            <Header />

            <div className="profil">

                <HeaderBox />

                <div className='content pos-r'>

                    <div className="c">

                        <HeaderProfile />

                    </div>

                    <div className="mt30">

                        <div className="c pos-r">

                            <ProfileMenu data="paiements" />

                            <div className="paiements">

                                <div className="bg6 p30 br10 mb20">

                                    {

                                        <>

                                            <Elements stripe={stripePromise}>
                                                <AddCardForm />
                                            </Elements>


                                            <div class="flex m_flex jc-center col-8 m0a"><img src="/image/paiement-securise2.webp" class="col-3 m_col_8 mt20" /></div>
                                            <p class="fz07 d-block ta-center mt10">Vous êtes sur un serveur de paiement sécurisé<br /> par les normes ssl (https).</p>

                                        </>


                                    }

                                </div>

                            </div>

                        </div>
                    </div>
                </div>

            </div>

            <Footer />

        </div>

    )

}

export default PaiementsAjouterCarte